import React from "react";
import { C, CES_COLS, CSAT_COLS } from "@tokens";

/**
 * DistBar — barra empilhada mostrando distribuição de CES ou CSAT.
 * Extraído verbatim do Dashboard121Insights (v45).
 *
 * @param {object}  dist   - objeto com chaves conforme CES_COLS ou CSAT_COLS
 * @param {"ces"|"csat"} tipo
 * @param {boolean} [small] - versão compacta (altura menor, sem legenda)
 */
export default function DistBar({ dist, tipo, small }) {
  if (!dist) return null;
  const cols = tipo === "ces" ? CES_COLS : CSAT_COLS;
  const topLabel =
    tipo === "ces"
      ? "Ext.Fácil + Fácil = Top2Box%"
      : "Satisfeito + Muito Satisfeito = CSAT%";
  return (
    <div>
      <div
        style={{
          display: "flex",
          height: small ? 6 : 10,
          borderRadius: small ? 3 : 5,
          overflow: "hidden",
          gap: 1,
        }}
      >
        {cols.map((c) => (
          <div
            key={c.k}
            title={`${c.l}: ${dist[c.k]}%`}
            style={{
              width: `${dist[c.k] || 0}%`,
              background: c.c,
              flexShrink: 0,
              transition: "width .5s",
            }}
          />
        ))}
      </div>
      {!small && (
        <>
          <div
            style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 6 }}
          >
            {cols.map((c) => (
              <div
                key={c.k}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 3,
                  fontSize: 10,
                  color: C.text3,
                }}
              >
                <div
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: 2,
                    background: c.c,
                  }}
                />
                {c.l} <b>{dist[c.k] || 0}%</b>
              </div>
            ))}
          </div>
          <div
            style={{
              fontSize: 10,
              color: C.text4,
              marginTop: 4,
              fontStyle: "italic",
            }}
          >
            {topLabel}
          </div>
        </>
      )}
    </div>
  );
}
